import React from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "reactstrap";
import LayoutStyles from "../baseStyles";

const NotFoundPage = () => (
  <main>
    <Helmet title="404" />
    <LayoutStyles>
      <Container className="text-center m-t-60">
        <h1>Page Not Found</h1>
        <p>Sorry, the page you were trying to view does not exist.</p>
      </Container>
    </LayoutStyles>
  </main>
);

export default NotFoundPage;
